import { useEffect } from 'react';
import archivar from "../../../../assets/vw/svg/archivar.svg";
import inactivo_icono from "../../../../assets/vw/svg/point-rojo.svg";
import activo_icono from "../../../../assets/vw/svg/point-verde.svg";
import unarchive from "../../../../assets/vw/svg/unarchive.svg";

const CardContenido = ({ infoCard, handleArchivar, editar, archivo, rowDesarchivar, setShowContent, getApp }) => {

    useEffect(() => {
        return () => {
            setShowContent(false);
        }
    }, [setShowContent])

    return (
        <>
            <div className={"select-card-content mb-4 mt-4"}>
                <div className={"d-flex"}>
                    <div className={"mr-5"}>
                        <div className="select-card-content-title">Rol:</div>
                        <div className="select-card-content-description">
                            {!infoCard.original.nombreRol ? '-' : infoCard.original.nombreRol.length > 20
                                ? `${infoCard.original.nombreRol.substring(0, 18)}…`
                                : infoCard.original.nombreRol}
                        </div>
                    </div>
                    <div className={"ml-4"}>
                        <div className="select-card-content-title">Aplicación:</div>
                        <div className="select-card-content-description">
                            {infoCard.original.app ? getApp(infoCard.original.app) : '-'}
                        </div>
                    </div>
                </div>
            </div>
            <div className="select-card-footer d-flex justify-content-between">
                <div className={""}>
                    {
                        archivo ? (
                            <img src={inactivo_icono} alt="activo"></img>
                        ) : (
                            <img className={"mr-3"} src={activo_icono} alt="activo"></img>
                        )
                    }
                </div>
                <div className={"d-flex align-items-end"}>
                    {
                        archivo ? (
                            <button
                                className="button_icon-vw btn-desarchivar"
                                type="button"
                                onClick={() => rowDesarchivar({ row: infoCard })}
                            >
                                <div className="aling-icon-desarchivar font-azul-claro-complementario">
                                    {" "}
                                    <img
                                        src={unarchive}
                                        alt="unarchive"
                                        className="px-1"
                                    ></img>{" "}
                                    Desarchivar
                                </div>
                            </button>
                        ) : (
                            <>
                                <button
                                    className="button_icon-vw"
                                    type="button"
                                    onClick={() => editar({ row: infoCard })}
                                >
                                    <div className="d-flex font-azul-claro-secundario">
                                        <div className={"editar-icon-mobile mr-2"}></div>
                                        Editar
                                    </div>
                                </button>
                                <button
                                    className="button_icon-vw"
                                    type="button"
                                    onClick={() => handleArchivar({ row: infoCard })}
                                >
                                    <div className="d-flex font-amarillo-complementario">
                                        {" "}
                                        <img
                                            src={archivar}
                                            alt="archivar"
                                            className="px-2"
                                        ></img>{" "}
                                        Archivar
                                    </div>
                                </button>
                            </>
                        )
                    }
                </div>
            </div>
        </>
    )
}

export default CardContenido